import classNames from 'classnames';
import styles from './VehicleHistory.module.css';
import {
  Row,
  Col,
  Space,
  Card,
  Tabs,
  TabsProps,
  ConfigProvider,
  Button,
  Select,
  Tooltip,
  Checkbox,
  Divider,
  Input,
  Spin,
} from 'antd';
import Modal from '../../components/Modal';
import React, { useState, useEffect } from 'react';
import Icon from '../../components/Icon/Icon';
import VehicleSessionHistory from '../../components/VehicleHistory/VehicleSessionHistory';
import VehicleModuleHistory from '../../components/VehicleHistory/VehicleModuleHistory';
import VehicleDtcHistory from '../../components/VehicleHistory/VehicleDtcHistory';
import VehicleDidHistory from '../../components/VehicleHistory/VehicleDidHistory';
import VehicleSymptomHistory from '../../components/VehicleHistory/VehicleSymptomHistory';
import VehicleCandidateHistory from '../../components/VehicleHistory/VehicleCandidateHistory';
import {
  getVehicleStatusModuleHistory,
  exportVehicleSessionHistory,
  getSessionModuleFiles,
} from 'src/app/query.service';

interface DataType {
  [key: string]: any;
}

const { Option } = Select;
const VehicleHistory: React.FC = () => {
  const [searchedVin, setSearchedVin] = useState('');
  const [showResult, setShowResult] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [downloadModalcontent, setDownloadModalcontent] = useState('');
  const [showDetailsView, setShowDetailsView] = useState(true);
  const [vehicleSummary, setVehicleSummary] = useState<{ [key: string]: any }>({});
  const [vehicleIQM, setVehicleIQM] = useState<{ [key: string]: any }>({});
  const [moduleHistory, setModuleHistory] = useState<DataType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sessionFiles, setSessionFiles] = useState<DataType[]>([]);
  const [selectedFiles, setSelectedFiles] = useState<string[]>([]);
  const [symptomHistory, setSymptomHistory] = useState<DataType[]>([]);
  const [candidateHistory, setCandidateHistory] = useState<DataType[]>([]);
  const [searchValue, setSearchValue] = useState('');
  const [modalLoading, setModalLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const getVehicleStatus = async () => {
    const userId = localStorage.getItem('userId');
    try {
      setModalLoading(true);
      const result: any = await getVehicleStatusModuleHistory('status', searchedVin);
      setVehicleSummary(result.vehicleSummary);
      setShowDetailsView(true);
      setVehicleIQM(result.vehicleIQM);
      setModuleHistory(result.vehicleHistModules);
      setCandidateHistory(result.vehicleCandidates);
      setSymptomHistory(result.vehicleSymptoms);
      setShowResult(true);
      setModalLoading(false);
    } catch (error) {
      setModalLoading(false);
    }
  };
  useEffect(() => {
    if (searchedVin !== '' && searchedVin.length == 17) {
      getVehicleStatus();
    }
  }, [searchedVin]);
  useEffect(() => {});
  const handleExportVehicleHistory = async () => {
    setIsLoading(true);
    const fileType =
      downloadModalcontent === 'Vehicle History Download Confirmation' ? 'vehicle' : 'session';
    try {
      const userId = localStorage.getItem('userId');
      let postData: any;
      let fileName = '';
      let url = '';
      if (fileType === 'session') {
        fileName = `Session_History_${searchedVin}` + '.zip';
        postData = sessionFiles.filter(
          (file) =>
            selectedFiles.includes(file.sourceFile) &&
            !file.sourceFile.toLowerCase().includes('topix')
        );
      } else {
        fileName = `Vehicle_History_${searchedVin}` + '.xlsx';
      }
      const result: any = await exportVehicleSessionHistory(searchedVin, fileType, postData);
      if (fileType === 'session') {
        const blob = new Blob([result], { type: 'application/zip' });
        const reader = new FileReader();
        reader.onload = (e) => {
          const arrayBuffer = reader.result as ArrayBuffer;
          const byteArray = new Uint8Array(arrayBuffer);
          const manualBlob = new Blob([byteArray], { type: 'application/zip' });
          const manualURL = window.URL.createObjectURL(manualBlob);
          const link = document.createElement('a');
          link.href = manualURL;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(manualURL);
        };
        reader.readAsArrayBuffer(blob);
      } else {
        url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleChange = (value: string[]) => {
    setSelectedFiles(value);
  };
  const handleSelectAll = (checked: ConstrainBoolean) => {
    const allValues = checked
      ? sessionFiles
          .filter(
            (file) => !file.sourceFile?.toLowerCase().includes('topix-diagnostic-restructure')
          )
          .map((file) => file.sourceFile)
      : [];
    setSelectedFiles(allValues);
    handleChange(allValues);
  };
  const filteredFiles = sessionFiles.filter(
    (file) =>
      file.fileName.toLowerCase().includes(searchValue.toLowerCase()) &&
      !file.sourceFile.toLowerCase().includes('topix-diagnostic-restructure')
  );
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchedVin(e.target.value);
    if (value.length > 0 && value.length !== 17) {
      setErrorMessage('VIN must be exactly 17 characters.');
    } else {
      setErrorMessage('');
    }
  };

  const handleDownloadClick = async (placeholder: string) => {
    if (placeholder === 'Session Files Download') {
      try {
        setDownloadModalcontent(placeholder);
        setOpenModal(true);
        setModalLoading(true);
        // const userId = localStorage.getItem('userId') || '';
        const result: any = await getSessionModuleFiles(searchedVin);
        setSessionFiles(result.items);
        setModalLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    } else {
      setDownloadModalcontent(placeholder);
      setOpenModal(true);
    }
  };
  const handleCancel = () => {
    setOpenModal(false);
    setSelectedFiles([]);
    setDownloadModalcontent('');
  };
  const toggleDetailsView = () => {
    setShowDetailsView(!showDetailsView);
  };
  const tabTheme = {
    components: {
      Tabs: {
        itemHoverColor: '#000000',
        itemSelectedColor: '#000000',
        itemColor: '#727272',
        titleFontSize: 16,
      },
    },
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Session History',
      children: <VehicleSessionHistory searchedVin={searchedVin} />,
    },
    {
      key: '2',
      label: 'DTC History',
      children: <VehicleDtcHistory searchedVin={searchedVin} />,
    },
    {
      key: '3',
      label: 'DID History',
      children: <VehicleDidHistory searchedVin={searchedVin} />,
    },
    // TODO: Implement logic to show tabs when required based on data
    {
      key: '4',
      label: 'Symptom History',
      children: <VehicleSymptomHistory propsData={symptomHistory} />,
    },
    {
      key: '5',
      label: 'Candidate History',
      children: <VehicleCandidateHistory propsData={candidateHistory} />,
    },
    {
      key: '6',
      label: 'Module History',
      children: <VehicleModuleHistory propsData={moduleHistory} />,
    },
  ];

  // TODO: Implement logic to populate data for the VIN in the first link
  const links = [
    {
      label: 'FMS',
      url: 'https://www.fms.jlrint.com:8089/VUTWEB/quickVehicleSearch.do?quickSearchValue=${searchedVin}',
    },
    {
      label: 'TOPIx',
      url: 'https://topix.jaguar.jlrext.com',
    },
    {
      label: 'IQM',
      url: 'https://iqm.gcp.jlrint.com/api/#/application/intro',
    },
    {
      label: 'GCM Jaguar',
      url: 'http://gcm.jlrint.com/jrepqr',
    },
    {
      label: 'GCM Land Rover',
      url: 'http://gcm.jlrint.com/lrepqr',
    },
  ];
  return (
    <div className={classNames(styles.VehicleHistory)}>
      {!showResult && (
        <div>
          <div className={classNames(styles['VehicleHistory--Headline'])}>
            <span>Vehicle History</span>
          </div>
          <div className={classNames(styles['VehicleHistory--PageContent'])}>
            <div className={classNames(styles['VehicleHistory--Search'])}>
              <input placeholder="Search" value={searchedVin} onChange={handleSearchChange}></input>
              {errorMessage && (
                <div className={classNames(styles['VehicleHistory--error-message'])}>
                  <p>{errorMessage}</p>
                </div>
              )}
            </div>
          </div>
          {modalLoading && (
            <div className={classNames(styles.center)}>
              <Spin size="large" className={classNames(styles['loader-color'])} />
            </div>
          )}
        </div>
      )}
      {showResult && (
        <div>
          <div className={classNames(styles['VehicleHistory--SearchHeading'])}>
            <Space>
              <h4 className={classNames(styles['VehicleHistory--HeadingText'])}>
                {searchedVin} - {vehicleSummary?.modelEnglish || 'Model Unknown'}
              </h4>
              <Tooltip title="Details View">
                <Button
                  type="text"
                  size="small"
                  onClick={toggleDetailsView}
                  className={styles['VehicleHistory--DetailsViewButton']}
                >
                  {showDetailsView ? <Icon name="remove" /> : <Icon name="add" />}
                </Button>
              </Tooltip>
            </Space>

            <Space>
              <Button
                className={classNames(styles['VehicleHistory--Buttons'])}
                onClick={() => handleDownloadClick('Vehicle History Download Confirmation')}
              >
                <span>Download Vehicle History</span>
              </Button>
              <Button
                className={classNames(styles['VehicleHistory--Buttons'])}
                onClick={() => handleDownloadClick('Session Files Download')}
              >
                <span>Download Session Files</span>
              </Button>
              {/* TODO: Implement logic for Vehicle/ Session history download and to populate the Session File Download dropdown with api call*/}
              <Modal
                open={openModal}
                // loading={isLoading}
                onClose={handleCancel}
                width={900}
                footer={[
                  <div key="vehicleModal" className={styles['VehicleHistory--ModalFooter']}>
                    <Space>
                      <Button
                        className={styles['VehicleHistory--Buttons']}
                        onClick={handleExportVehicleHistory}
                        loading={isLoading}
                      >
                        {' '}
                        Download{' '}
                      </Button>
                      <Button
                        onClick={handleCancel}
                        className={styles['VehicleHistory--CancelButton']}
                      >
                        Cancel
                      </Button>
                    </Space>
                  </div>,
                ]}
              >
                <div className={classNames(styles['VehicleHistory--ModalHeader'])}>
                  {downloadModalcontent}
                </div>
                <div className={classNames(styles['VehicleHistory--ModelContent'])}>
                  {downloadModalcontent === 'Vehicle History Download Confirmation' && (
                    <p>
                      Be advised, dependent on vehicle session activity, this extract can take up to
                      5 minutes to complete.
                    </p>
                  )}
                  {/* {downloadModalcontent === 'Session Files Download' && (
                   <Select
                   mode="multiple"
                   maxTagCount={2}
                     style={{ width: '100%' }} 
                     placeholder="Click to select session files"
                     onChange={handleChange}
                   >
                     {sessionFiles.map((n, index)=>{
                       return <Option key={`file${index}`} value={n.sourceFile}>{n.fileName}</Option>
                     })}
                   </Select>
                  )} */}
                  {downloadModalcontent === 'Session Files Download' && (
                    <>
                      {modalLoading ? (
                        <div className={classNames(styles.center)}>
                          <Spin className={classNames(styles['loader-color'])} />
                        </div>
                      ) : (
                        <Select
                          showSearch={true}
                          mode="multiple"
                          maxTagCount={2}
                          value={selectedFiles}
                          style={{ width: '100%' }}
                          placeholder="Click to select session files"
                          onChange={handleChange}
                          dropdownRender={(menu) => (
                            <>
                              <Checkbox
                                checked={selectedFiles.length === sessionFiles.length}
                                indeterminate={
                                  selectedFiles.length > 0 &&
                                  selectedFiles.length < sessionFiles.length
                                }
                                onChange={(e) => handleSelectAll(e.target.checked)}
                                style={{ padding: '8px 12px', width: '100%' }}
                              >
                                Select All
                              </Checkbox>
                              <Input
                                placeholder="Search files"
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                                style={{ marginBottom: 8, width: '100%' }}
                              />
                              <Divider style={{ margin: '8px 0' }} />
                              {menu}
                            </>
                          )}
                        >
                          {filteredFiles.map((n, index) => {
                            return (
                              <Option key={`file${index}`} value={n.sourceFile}>
                                {n.fileName}
                              </Option>
                            );
                          })}
                        </Select>
                      )}
                    </>
                  )}
                </div>
                {/* <div className={styles['VehicleHistory--ModalFooter']}>
                  <Space>
                    {downloadModalcontent === 'Vehicle History Download Confirmation'?
                    <Button
                    className={styles['VehicleHistory--Buttons']}
                    onClick={handleExportVehicleHistory}
                    > Download </Button>
                    :<Button className={styles['VehicleHistory--Buttons']}> Download </Button>
                    
                    
                    }
                    <Button
                      onClick={() => setOpenModal(false)}
                      className={styles['VehicleHistory--CancelButton']}
                    >
                      Cancel
                    </Button>
                  </Space>
                </div> */}
              </Modal>
            </Space>
          </div>
          <div className={classNames(styles['VehicleHistory--PageContent'])}>
            {showDetailsView && (
              <Card className={classNames(styles['VehicleHistory--Card'])}>
                <div className={classNames(styles['VehicleHistory--CardContent'])}>
                  <div className={classNames(styles['VehicleHistory--CardContentDivision'])}>
                    <div className={classNames(styles['VehicleHistory--CardContentHeader'])}>
                      Vehicle Summary
                    </div>
                    <div className={classNames(styles['VehicleHistory--Table'])}>
                      <Row gutter={16}>
                        <Col span={8} className={classNames(styles['VehicleHistory--RowHeader'])}>
                          Description
                        </Col>
                        <Col span={16} className={classNames(styles['VehicleHistory--RowHeader'])}>
                          Value
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}> VIN </Col>
                        <Col span={16}> {vehicleSummary.vin} </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}> Model </Col>
                        <Col span={16}> {vehicleSummary.modelEnglish} </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}> Model Code </Col>
                        <Col span={16}> {vehicleSummary.modelCode} </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}> Model Year </Col>
                        <Col span={16}> {vehicleSummary.modelYear} </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}> Engine </Col>
                        <Col span={16}> {vehicleSummary.engine} </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}> Gearbox </Col>
                        <Col span={16}> {vehicleSummary.gearbox} </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}> Plant </Col>
                        <Col span={16}> {vehicleSummary.plant} </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}> Emission Type </Col>
                        <Col span={16}> {vehicleSummary.emissionType} </Col>
                      </Row>
                    </div>
                  </div>
                  <div className={classNames(styles['VehicleHistory--CardContentDivision'])}>
                    <div className={classNames(styles['VehicleHistory--CardContentHeader'])}>
                      IQM Data
                    </div>
                    <div className={classNames(styles['VehicleHistory--Table'])}>
                      <Row gutter={16}>
                        <Col span={8} className={classNames(styles['VehicleHistory--RowHeader'])}>
                          Description
                        </Col>
                        <Col span={16} className={classNames(styles['VehicleHistory--RowHeader'])}>
                          Value
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}> Build Date </Col>
                        <Col span={16}> {vehicleIQM.buildDate} </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}> Sale Date </Col>
                        <Col span={16}> {vehicleIQM.saleDate} </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}> Warranty Date </Col>
                        <Col span={16}> {vehicleIQM.warrantyDate}</Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}> Gate Date </Col>
                        <Col span={16}> {vehicleIQM.gateDate} </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}> Number Of Claims </Col>
                        <Col span={16}> {vehicleIQM.numberOfClaims} </Col>
                      </Row>
                    </div>
                    <div
                      className={classNames(styles['VehicleHistory--CardContentHeader'])}
                      style={{ marginTop: '15px' }}
                    >
                      Internal Links - Accounts Required
                    </div>
                    <div className={classNames(styles['VehicleHistory--LinksContainer'])}>
                      {links.map((link) => (
                        <a
                          key={link.label}
                          href={link.url}
                          target="_blank"
                          className={classNames(styles['VehicleHistory--LinksItem'])}
                          rel="noreferrer"
                        >
                          {link.label}
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </Card>
            )}
            <div className={classNames(styles['VehicleHistory--GridContainer'])}>
              <ConfigProvider theme={tabTheme}>
                <Tabs
                  type="card"
                  defaultActiveKey="1"
                  items={items.filter((item) => {
                    if (item.key === '4' && symptomHistory.length === 0) {
                      return false;
                    }
                    if (item.key === '5' && candidateHistory.length === 0) {
                      return false;
                    }
                    return true;
                  })}
                />
              </ConfigProvider>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VehicleHistory;
